import { createContext } from "react";
import { Company, CompanyScores } from "src/api/client-api/company/useGetOneCompany";

export type CompanyMetadataInit = {
    company: Omit<Company, keyof CompanyScores>;
};
export const CompanyMetadataContext = createContext<CompanyMetadataInit | null>(null);
